import React, {useContext} from "react";
import {Route, Redirect} from 'react-router-dom';
import AuthContext, {withAuthContextProvider, withAuthContextReady} from "../context/AuthContext";
import {compose} from "recompose";


const ProtectedRoute = ({component: Component, requirePassphrase, ...rest}) => {
    const {isAuth, hasValidatedPassphrase} = useContext(AuthContext)
    return (
        <Route {...rest} render={props => {
            if (requirePassphrase) {
                return (
                    isAuth && hasValidatedPassphrase ?
                        <Component {...props} />
                        : <Redirect to="/validate-passphrase"/>
                )
            } else {
                return (
                    isAuth ?
                        <Component {...props} />
                        : <Redirect to="/"/>
                )
            }
        }}/>
    );
};

export default compose(withAuthContextProvider, withAuthContextReady)(ProtectedRoute);
